export enum AdyenMessage {
  HEIGHT = 'height',
  SHOW_OVERLAY = 'showOverlay',
  HIDE_OVERLAY = 'hideOverlay',
  PLACE_ORDER = 'placeOrder',
  ERROR = 'error',
  REFETCH_CART = 'refetchCart'
}
